// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7d9ce","dragging":"_54bf6"};